import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-statuses.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-statuses.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, } from "@angular/core";
import { ApplicationSummaryService } from "../application-summary/shared/application-summary.service";
import { forkJoin } from "rxjs";
import { ApplicationSummaryConstants } from "../application-summary/application-summary.constants";
import { AppControllerService } from "../../../app-controller.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
let ApplicationStatusesComponent = class ApplicationStatusesComponent {
    summaryService;
    appService;
    changeDetection;
    moduleID;
    isLoading = false;
    getStatusTotalCountSubscription;
    selectedCategory;
    selectedCategorySubscription;
    constructor(summaryService, appService, changeDetection) {
        this.summaryService = summaryService;
        this.appService = appService;
        this.changeDetection = changeDetection;
    }
    dataProgresses;
    title = ApplicationSummaryConstants.IN_PROGRESS_TEXT;
    noItem = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    ngOnInit() {
        this.selectedCategorySubscription = this.summaryService.$selectedCategory.subscribe(category => {
            this.selectedCategory = category;
            if (this.selectedCategory !== null) {
                this.initProgressbars();
            }
        });
    }
    initProgressbars() {
        this.isLoading = true;
        const category = this.selectedCategory === ApplicationSummaryConstants.CATEGORY_PLACEHOLDER ? "" : this.selectedCategory;
        this.getStatusTotalCountSubscription = forkJoin({
            getStatusCount: this.summaryService.getStatusCount(+this.appService.selectedModuleID, category),
            getStatusTotalCount: this.summaryService.getStatusTotalCount(+this.appService.selectedModuleID, category),
        }).subscribe(({ getStatusCount, getStatusTotalCount }) => {
            const dataProgresses = new Array();
            const statusSubtotal = getStatusCount;
            const totalStatusCount = getStatusTotalCount;
            statusSubtotal.forEach((element) => {
                dataProgresses.push({
                    Status: element.status,
                    SubTotal: element.count,
                    Percentage: this.formula(element.count, totalStatusCount),
                });
            });
            this.dataProgresses = dataProgresses;
            this.isLoading = false;
            this.changeDetection.markForCheck();
        });
    }
    formula(nbr, totalCount) {
        return (nbr * 100) / totalCount;
    }
    filterApplication(status) {
        this.summaryService.filterApplicationsByStatus(status);
    }
    static ctorParameters = () => [
        { type: ApplicationSummaryService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ApplicationStatusesComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-application-statuses",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ApplicationStatusesComponent);
export { ApplicationStatusesComponent };
